// @flow

export * as ThemeColors from './themeColors';
export * as ColorNames from '../common/colorNames';

export const Config = {
  name: 'Dark Theme',
  className: 'trustar-dark',
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/splunk-dark/index.js